import React from "react";
import Headertop from '../components/Headertop';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function IITGate (){
    return (
        <>
            <Headertop /> 
            <Navbar />
            
            <Footer />
        </>
    );
}
export default IITGate;